import './index.scss'
$("header").addClass("head1");
$("#nav6").addClass("active");